export const itIT = {
    price: 'Prezzo',
    apply: 'Applica',
    applyFilter: 'Applica filtri',
    filterFor: 'Filtra per',
    default: 'Predefinito',
    orderBy: 'Ordina per',
    alphabetic: 'Alfabetico',
    newest: 'Ultimi arrivi',
    popularity: 'Popolarità',
    priceHighToLow: 'Prezzo in ordine decrescente',
    priceLowToHigh: 'Prezzo in ordine crescente',
    showMore: 'Mostra successivi',
    showPrev: 'Mostra precedenti',
    noProductsFound: 'Nessun prodotto trovato',
    from: 'da',
    outOfStock: 'Non disponibile',
    addToCart: 'Aggiungi al carrello',
    addProductToCart: 'Aggiungi {0} al carrello',
    showProduct: 'Scopri di più',
    loadMore: 'Carica altri',
    resetFilters: 'Clean Filters',
};
export default itIT;
